/**
 * Read-only mode for a past HELM run (A7Y-3872, D15).
 *
 * `HelmPage` provides `true` through this context whenever `?run=<runId>` is
 * present; `ItemActions`, `ItemActionsMenu` and `Proposals` read it to remove
 * every action surface. A context is used rather than threading an optional
 * `onAction` through every intervening section (`Changes.tsx`,
 * `JudgmentQueue.tsx`, `ShippedSection.tsx`, `Watched.tsx`,
 * `OverdueStale.tsx`, `CallIntake.tsx`) — those keep passing the live
 * `handleAction`/`onUndo` callbacks unconditionally, and the two leaf
 * components decide whether to expose a button for them.
 */
import { createContext, useContext } from 'react';

export const HelmReadOnlyContext = createContext(false);

export function useHelmReadOnly(): boolean {
  return useContext(HelmReadOnlyContext);
}
